export default __webpack_public_path__ + "static/Propane-Tank-Removal-c5881ddbd8b34dd37f4f3ac357bcfe42.jpg";